import React, { Fragment, useContext } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { FormsGlobalContext } from '@mummssoftware/global-context';
import { Context } from '../../context';
import { ReqFieldDiv } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

const StyledSwitch = withStyles((theme) => ({
  switchBase: {
    color: theme.palette.common.white,
    '&$checked': {
      color: theme.palette.primary.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  checked: {},
  track: {},
}))(Switch);

export const CompletedFormSwitch = () => {
  // todo GLOBAL CONTEXT
  const {
    getCompletedForms,
    getInProgressForms,
    setCompletedMode,
    setInProgressMode,
    agency,
    patient,
    isCompletedMode,
    formsListLoading,
  } = useContext(Context);
  const { fajitaQuestionnaireFormGlobal } = useContext(FormsGlobalContext);
  const isNarrowPhoneView = useMediaQuery('(max-width:600px)', {
    noSsr: true,
  });
  const showSwitch = !fajitaQuestionnaireFormGlobal;
  // first API call made for Completed Forms
  const handleChange = () => {
    if (isCompletedMode) {
      setInProgressMode();
      getInProgressForms(patient?.patientNumber as string, agency);
    } else {
      setCompletedMode();
      getCompletedForms(patient?.patientNumber as string, agency);
    }
  };

  return showSwitch ? (
    <Fragment>
      <Typography component="div" variant="body2" style={{ letterSpacing: 0 }}>
        <Grid component="div" container alignItems="center">
          <ReqFieldDiv>
            {isNarrowPhoneView ? defaults.wip : defaults.inProgress}
          </ReqFieldDiv>
          <Grid item>
            <StyledSwitch
              checked={isCompletedMode}
              onChange={handleChange}
              name="checked"
              disabled={formsListLoading}
            />
          </Grid>
          <ReqFieldDiv>
            {isNarrowPhoneView ? defaults.done : defaults.completed}
          </ReqFieldDiv>
        </Grid>
      </Typography>
    </Fragment>
  ) : (
    <></>
  );
};
export default CompletedFormSwitch;
